<template>
    <div
        v-if="dataInstagram"
        class="text-center"
    >
        <h2
            class="py-0 my-0"
        >
            #{{ product.hashtag }}
        </h2>
        Show us your
        <strong>{{ product.name }}</strong>
        to be reposted by
        <div>
            <a :href="dataInstagram.link" target="_blank">
                <strong>@{{ dataInstagram.username }}</strong>
            </a>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import type { Product } from '~/types';
    import type { SocialMediaLinkItem } from 'x1-base/types';

    defineProps({
        product: {
            type: Object as PropType<Product>,
            required: true
        }
    });

    const $config = useRuntimeConfig();
    const links = $config.public.social.links as Nilish<SocialMediaLinkItem[]>;
    const dataInstagram = ref<Nullable<SocialMediaLinkItem>>(
        links?.find((o) => o.network === 'Instagram') ?? null
    );
</script>

<style lang="scss" scoped></style>
